export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-5 leading-tight">
            Mach den nächsten Schritt mit OOPBUY Spreadsheet
          </h2>
          <p className="text-base md:text-lg text-foreground-500 mb-10 leading-relaxed">
            Entdecke tausende Premium-Produkte auf kaspreadsheet.com mit den besten Bewertungen und sichersten Verkäufern. Dein Zugang zu internationaler Mode beginnt hier.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2.5 px-10 py-4 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300"
          >
            Jetzt bei kaspreadsheet.com shoppen
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-16 w-full overflow-hidden rounded-2xl">
          <div
            className="w-full h-[200px] md:h-[280px] bg-cover bg-center"
            style={{
              backgroundImage: 'url(https://readdy.ai/api/search-image?query=Curated%20fashion%20lifestyle%20banner%20with%20beige%20trench%20coats%20neutral%20knitwear%20leather%20accessories%20and%20minimalist%20sneakers%20arranged%20on%20clean%20white%20surface%20soft%20natural%20daylight%20editorial%20composition%20warm%20earthy%20tones%20sophisticated%20relaxed%20aesthetic&width=1400&height=560&seq=cta-banner-2026&orientation=landscape)',
            }}
          />
        </div>
      </div>
    </section>
  );
}